import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

const FormattedPrice = ({ type, price }) => {
    const clsd = 'CLSD: Com leis sociais desonerado';
    const clsn = 'CLSN: Com leis sociais não desonerado';
    const sls = 'SLS: Sem leis sociais';

    const formattedPrice = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(price);

    if (!type) {
        return <span>{formattedPrice}</span>;
    }

    const popover = (
        <Popover id="badge-popover">
            <Popover.Body>
                {type === 'clsd' ? clsd : type === 'clsn' ? clsn : sls}
            </Popover.Body>
        </Popover>
    );

    return <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="top"
        overlay={popover}
    ><span>{formattedPrice}</span></OverlayTrigger>;
};

export default FormattedPrice;